import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import { debounce } from 'Util/Request';

import ProductTabs from './ProductTabs.component';
import {
    PRODUCT_TABS_FIRST_GROUP,
    PRODUCT_TABS_LAST_GROUP,
    TABS_SCROLL_BOTTOM_TRESHOLD,
    TABS_SCROLL_DEBOUNCE_DELAY,
    TABS_SCROLL_TOP_TRESHOLD,
} from './ProductTabs.config';

/** @namespace Advox/Component/ProductTabs/Container */
export class ProductTabsContainer extends PureComponent {
    static props = {
        withHeader: PropTypes.bool,
        group: PropTypes.string,
    };

    static defaultProps = {
        withHeader: false,
        group: null,
    };

    state = {
        inViewPort: false,
    };

    componentDidMount() {
        this.debouncedTabsScroll = debounce(this.checkInViewPort.bind(this), TABS_SCROLL_DEBOUNCE_DELAY);

        window.addEventListener('scroll', this.debouncedTabsScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.debouncedTabsScroll);
    }

    checkInViewPort() {
        const firstGroup = document.getElementById(PRODUCT_TABS_FIRST_GROUP);
        const lastGroup = document.getElementById(PRODUCT_TABS_LAST_GROUP);

        if (firstGroup && lastGroup) {
            const { top } = firstGroup.getBoundingClientRect();
            const { bottom } = lastGroup.getBoundingClientRect();

            this.setState({ inViewPort: top < TABS_SCROLL_TOP_TRESHOLD && bottom > TABS_SCROLL_BOTTOM_TRESHOLD });
        }
    }

    containerProps() {
        const { inViewPort } = this.state;
        const { tabs, defaultTab, withHeader, group } = this.props;

        return {
            inViewPort,
            tabs,
            defaultTab,
            withHeader,
            group,
        };
    };

    render() {
        return <ProductTabs {...this.containerProps()} />;
    }
}

export default ProductTabsContainer;
